export const TimesCaptcha = {
    DEFAULT_TIME: '120',
};
